import { render, staticRenderFns } from "./OrderBestellung.vue?vue&type=template&id=8fca7abc&scoped=true&"
import script from "./OrderBestellung.vue?vue&type=script&lang=js&"
export * from "./OrderBestellung.vue?vue&type=script&lang=js&"
import style0 from "./OrderBestellung.vue?vue&type=style&index=0&id=8fca7abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fca7abc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
